import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumberFormat'
})
export class PhoneNumberFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Remove all non-digit characters from the input value
    const phoneNumber = value.replace(/\D/g, '');

    // Format the phone number based on its length
    let formattedPhoneNumber = '';
    if (phoneNumber.length < 4) {
      formattedPhoneNumber = phoneNumber;
    } else if (phoneNumber.length < 7) {
      formattedPhoneNumber = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    } else {
      formattedPhoneNumber = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
    }

    return formattedPhoneNumber;
  }
}
